import type { BillingType } from "~/models/DealBilling";
import { generatePath } from "~/utils/generatePath";

export const getDownloadPath = (
	dealId: number,
	billingType: BillingType
): string => {
	const url = new URL(
		generatePath("/api/deals/:deal_id/deal_billing_estimation_files", {
			deal_id: dealId
		}),
		process.env.NEXT_PUBLIC_API_HOST
	);
	url.searchParams.set("billing_type", billingType);
	return url.toString();
};
